import { createInjectionState } from "@maine-cat/common/utils"
import { Ref } from "vue"

const injectKey = Symbol("tabs-index")

export const [provideTabs, useTabs] =
  createInjectionState(injectKey, (current: Ref<number>) => current)
